import axios from 'axios';
import type {
  AnsweringServiceType,
  AnsweringSubscriptionTag,
} from '@bb/domain/dist/types/AnsweringSubscription';
import type { OrgDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';

type GetSearchOrgsResponse = {
  orgs: (OrgDoc & { subscriptionTag?: AnsweringSubscriptionTag })[];
  count: number;
  total?: number;
};

export type SearchOrgs = JsonObject<GetSearchOrgsResponse>;

export const orgs = async (params: {
  input?: string;
  limit?: number;
  from?: number;
  sortField?: string;
  sortDir?: 'asc' | 'desc';
  mlsTypes?: string | string[];
  plans?: string[];
  statuses?: string[];
  fetchUnconfigured?: boolean;
  fetchLockboxCounts?: boolean;
  answeringSubscribed?: boolean;
  answeringServiceTypes?: (AnsweringServiceType | 'ns' | 'on')[];
  features?: string[];
}) => {
  const {
    data: { orgs: orgResult, count, total },
  } = await axios.get<SearchOrgs>('/search/orgs', { params });
  return {
    orgs: orgResult,
    count,
    ...(typeof total === 'number' && { total }),
  };
};
